import { httpRequest } from "@follaw-fr/utils/request.utils";
import { handleNetworkError } from "@follaw-fr/utils/handleNetworkError";

export const fetchArticles = async (payload) => {
  try {
    const response = await httpRequest("post", "/links", payload);
    return response.data;
  } catch (err) {
    handleNetworkError(err);
  }
};
